import classnames from 'classnames';
import React from 'react';
import TouchFeedback from 'rmc-feedback';
import Icon from '../icon';
import './style.less';
import { createElement } from 'react';
Button.defaultProps = {
    type: 'primary',
    disabled: false,
    size: 'normal',
    inline: false,
    title: '按钮文本',
    loading: false,
    activeStyle: {},
    href: '',
    activeColor: '',
    fixedWidth: '',
    isRadius: true,
};
const prefixCls = 'im-button';
function Button(props) {
    console.log('000000999999999');
    const { type, disabled, size, fixedWidth, title, inline, loading, className, icon, source, hasIcon, buttonHeight, height, buttonWidth, width, borderRadius, activeColor, pressInColor, pressBorder, buttonStyle, activeClassName, activeStyle, href, isRadius, onClick, } = props;
    const attributeMap = {
        height: height || buttonHeight,
        width: width || buttonWidth,
    };
    const iconType = loading ? 'loading' : icon;
    const wrapCls = classnames(prefixCls, className, {
        [`${prefixCls}-primary`]: type === 'primary',
        [`${prefixCls}-ghost`]: type === 'ghost',
        [`${prefixCls}-isRadius-middle`]: size === 'middle' && !isRadius,
        [`${prefixCls}-isRadius-small`]: size === 'small' && !isRadius,
        [`${prefixCls}-link`]: type === 'link',
        [`${prefixCls}-textLink`]: type === 'textLink',
        [`${prefixCls}-normal`]: size === 'normal',
        [`${prefixCls}-small`]: size === 'small',
        [`${prefixCls}-middle`]: size === 'middle',
        [`${prefixCls}-smallest`]: size === 'smallest',
        [`${prefixCls}-smallest-long`]: size === 'smallest' && !isRadius && fixedWidth === 'long',
        [`${prefixCls}-smallest-auto`]: size === 'smallest' && !isRadius && fixedWidth === 'auto',
        [`${prefixCls}-size-L-short`]: size === 'middle' && fixedWidth === 'short' && isRadius,
        [`${prefixCls}-size-M-short`]: size === 'small' && fixedWidth === 'short' && isRadius,
        [`${prefixCls}-size-S-short`]: size === 'smallest' && fixedWidth === 'short' && isRadius,
        [`${prefixCls}-size-L-long`]: size === 'middle' && fixedWidth === 'long' && isRadius,
        [`${prefixCls}-size-M-long`]: size === 'small' && fixedWidth === 'long' && isRadius,
        [`${prefixCls}-size-S-long`]: size === 'smallest' && fixedWidth === 'long' && isRadius,
        [`${prefixCls}-inline`]: inline,
        [`${prefixCls}-disabled`]: disabled,
        [`${prefixCls}-isRadius`]: isRadius,
        [`${prefixCls}-loading`]: loading,
        [`${prefixCls}-icon`]: Boolean(iconType),
    });
    let newtitle;
    if (size === 'smallest' && title && title.length > 4) {
        newtitle = title;
    }
    else {
        newtitle = title;
    }
    let iconEl;
    if (typeof iconType === 'string') {
        iconEl = (createElement(Icon, { "aria-hidden": "true", type: iconType, size: size === 'small' ? 'xxs' : 'md', className: `${prefixCls}-icon` }));
    }
    else if (iconType) {
        const rawCls = iconType.props?.className;
        const cls = classnames('im-icon', `${prefixCls}-icon`, size === 'small' ? 'im-icon-xxs' : 'im-icon-md');
        iconEl = React.cloneElement(iconType, {
            className: rawCls ? `${rawCls} ${cls}` : cls,
        });
    }
    let leftIcon;
    if (hasIcon) {
        if (size === 'normal' || size === 'middle') {
            leftIcon = source;
        }
    }
    let buttonColor;
    if (!disabled) {
        if (type === 'ghost') {
            buttonColor = '#fff';
        }
        else if (type === 'link') {
            buttonColor = '#fff';
        }
        else {
            buttonColor = activeColor;
        }
    }
    const _onClick = (e) => {
        if (type !== 'link' && type !== 'textLink') {
            e.preventDefault();
        }
        if (!href) {
            e.preventDefault();
        }
        onClick?.();
    };
    console.log("⭐️⭐️⭐️⭐️⭐️⭐️⭐️⭐️⭐️⭐️⭐️");
    return (createElement(TouchFeedback, { activeClassName: activeClassName || (activeStyle ? `${prefixCls}-active` : undefined), disabled: disabled, activeStyle: {
            backgroundColor: pressInColor,
            border: pressBorder,
        } },
        createElement("a", { role: "button", href: ((type === 'link' || type === 'textLink') && href) ? href : undefined, "aria-label": title, className: wrapCls, "aria-disabled": disabled, "aria-hidden": disabled ? 'true' : 'false', onClick: disabled ? undefined : _onClick, style: {
                borderRadius,
                height: attributeMap.height ? attributeMap.height : undefined,
                width: attributeMap.width ? attributeMap.width : undefined,
                lineHeight: `${attributeMap.height}px`,
                backgroundColor: buttonColor,
                ...buttonStyle,
            } },
            leftIcon !== undefined ? (createElement("img", { className: 'button-icon', src: source })) : null,
            iconEl && createElement("div", { className: 'button-icon' },
                " ",
                iconEl),
            newtitle)));
}
export default Button;
